export default "__VITE_ASSET__FvTV8di___"